// Import CSS
import '../projects/css/projects-modern.css';

// Import projects data
import projectsData from '../projects/projects-data.js';

// Make projectsData available globally
window.projectsData = projectsData;
console.log('Projects data loaded:', projectsData);

// Projects page JavaScript functionality
document.addEventListener('DOMContentLoaded', function() {
    const projectsGrid = document.getElementById('projectsGrid');
    const searchInput = document.getElementById('searchInput');
    const searchButton = document.getElementById('searchButton');
    const tagsContainer = document.getElementById('tagsContainer');

    let activeTags = [];
    let filteredProjects = projectsData || [];
    
    // Check if projectsData is available
    if (!projectsData || !Array.isArray(projectsData)) {
        console.error('Projects data is not available or not an array:', projectsData);
        if (projectsGrid) {
            projectsGrid.innerHTML = '<div style="text-align:center;color:var(--gray-500);font-size:1.2rem;">Error loading projects data.</div>';
        }
        return;
    }

    function getAllTags(projects) {
        const tagSet = new Set();
        projects.forEach(p => p.tags.forEach(tag => tagSet.add(tag)));
        return Array.from(tagSet).sort();
    }

    function renderTags() {
        if (!tagsContainer) return;
        
        tagsContainer.innerHTML = '';
        const allTags = getAllTags(projectsData);
        allTags.forEach(tag => {
            const btn = document.createElement('button');
            btn.className = 'tag-btn' + (activeTags.includes(tag) ? ' active' : '');
            btn.textContent = tag;
            btn.onclick = () => toggleTag(tag);
            tagsContainer.appendChild(btn);
        });
        if (activeTags.length > 0) {
            const clearBtn = document.createElement('button');
            clearBtn.className = 'clear-filters-btn';
            clearBtn.textContent = 'Clear Filters';
            clearBtn.onclick = clearFilters;
            tagsContainer.appendChild(clearBtn);
        }
    }

    function renderProjects(projectsToRender) {
        if (!projectsGrid) return;
        
        projectsGrid.innerHTML = '';
        if (projectsToRender.length === 0) {
            projectsGrid.innerHTML = '<div style="text-align:center;color:var(--gray-500);font-size:1.2rem;">No projects found.</div>';
            return;
        }
        projectsToRender.forEach((project, idx) => {
            const card = document.createElement('div');
            const isCurrentProject = project.tags.includes('Current Project');
            card.className = `project-card${isCurrentProject ? ' current-project' : ''}`;
            card.style.animationDelay = (idx * 0.07) + 's';
            card.innerHTML = `
                <img src="${project.image}" alt="${project.title}" class="project-image" />
                <div class="project-content">
                    <h3 class="project-title">${project.title}</h3>
                    <div class="project-tags">
                        ${project.tags.map(tag => `<span class="project-tag${activeTags.includes(tag) ? ' active' : ''}" data-tag="${tag}">${tag}</span>`).join('')}
                    </div>
                    <div class="project-description">${project.description}</div>
                    <a href="${project.link}" class="project-link" target="_blank" rel="noopener">View Project</a>
                </div>
            `;
            projectsGrid.appendChild(card);
        });
        document.querySelectorAll('.project-tag').forEach(el => {
            el.onclick = () => toggleTag(el.dataset.tag);
        });
    }

    function filterProjects() {
        const search = searchInput ? searchInput.value.trim().toLowerCase() : '';
        
        // Safety check for projectsData
        if (!projectsData || !Array.isArray(projectsData)) {
            console.error('Cannot filter: projectsData is not available');
            return;
        }
        
        filteredProjects = projectsData.filter(project => {
            const inText = project.title.toLowerCase().includes(search) ||
                           project.description.toLowerCase().includes(search) ||
                           project.tags.some(tag => tag.toLowerCase().includes(search));
            const hasTags = activeTags.length === 0 || activeTags.every(tag => project.tags.includes(tag));
            return inText && hasTags;
        });
        renderProjects(filteredProjects);
        renderTags();
    }

    function toggleTag(tag) {
        if (activeTags.includes(tag)) {
            activeTags = activeTags.filter(t => t !== tag);
        } else {
            activeTags.push(tag);
        }
        filterProjects();
    }

    function clearFilters() {
        activeTags = [];
        if (searchInput) searchInput.value = '';
        filterProjects();
    }

    // Event listeners
    if (searchButton) {
        searchButton.addEventListener('click', filterProjects);
    }
    
    if (searchInput) {
        searchInput.addEventListener('keydown', e => {
            if (e.key === 'Enter') filterProjects();
        });
    }

    // Mobile menu functionality
    const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
    const navLinks = document.querySelector('.nav-links');
    
    if (mobileMenuBtn && navLinks) {
        mobileMenuBtn.addEventListener('click', function() {
            this.classList.toggle('active');
            navLinks.classList.toggle('active');
        });
    }

    // Initialize
    filterProjects();
});
